import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { BrandName } from './BrandName';
export function Footer() {
  return <footer className="bg-sum-charcoal text-white pt-16 pb-8" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-76">
          <div className="col-span-1 md:col-span-2" data-id="element-77">
            <div className="bg-white p-2 rounded-lg inline-block mb-6" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/6cUEwm9nWDESrDmpRk3ub3/sum_logo.jpg" alt="SalesUp Marketing Logo" className="h-12 w-auto" data-id="element-79" />
            </div>
            <p className="text-gray-400 text-lg mb-6 max-w-md" data-id="element-80">
              Expert Web Development, Social Media Management & SEO to Boost
              Your Business Online. We make digital marketing simple and
              effective.
            </p>
            <div className="flex space-x-4" data-id="element-81">
              <a href="https://www.facebook.com/me/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-82">
                <Facebook size={24} data-id="element-83" />
              </a>
              <a href="#" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-84"></a>
              <a href="https://www.instagram.com/salesupmarketing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-85">
                <Instagram size={24} data-id="element-86" />
              </a>
              <a href="#" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-87"></a>
            </div>
          </div>

          <div data-id="element-88">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-89">Quick Links</h4>
            <ul className="space-y-4" data-id="element-90">
              <li data-id="element-91">
                <a href="/#about" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-92">
                  About Us
                </a>
              </li>
              <li data-id="element-93">
                <a href="/#services" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-94">
                  Our Services
                </a>
              </li>
              <li data-id="element-95">
                <a href="/#testimonials" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-96">
                  Testimonials
                </a>
              </li>
              <li data-id="element-97">
                <a href="/#contact" className="text-gray-400 hover:text-sum-green transition-colors" data-id="element-98">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-99">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-100">Services</h4>
            <ul className="space-y-4" data-id="element-101">
              <li className="text-gray-400" data-id="element-102">Web Development</li>
              <li className="text-gray-400" data-id="element-103">Social Media Management</li>
              <li className="text-gray-400" data-id="element-104">SEO Optimization</li>
              <li className="text-gray-400" data-id="element-105">Digital Strategy</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-106">
          <p className="text-gray-500 text-sm mb-4 md:mb-0" data-id="element-107">
            &copy; {new Date().getFullYear()} <BrandName data-id="element-108" /> Marketing. All
            rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-109">
            <a href="#" className="hover:text-white transition-colors" data-id="element-110">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}